import {
    ajaxP,
    ajax
} from '@/utils/request'

// 验证身份证
export function verificationId(params) {
    return ajax('api/v1/ocr/OCRIdCard', params)
}
// 验证银行卡
export function verificationBank(params) {
    return ajax('api/v1/ocr/OCRBankCard', params)
}

// 验证银行卡
export function bankTypeData(params) {
    return ajax('api/v1/bankCardTypes')
}

// 实名认证
export function verificationUser(params) {
    return ajaxP('api/v1/customerVerifies', params)
}